import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import useLicenseCheck from "license/useLicenseCheck";
export const AI_CONFIGURATION_QUERY_STRING = "ai-configuration";
const getAIReportConfiguration = () => AIConfig.aiClusterConfig().then((response) => ({
  isEnabled: (response == null ? void 0 : response.ai_enabled) !== false
}));
const useAIConfiguration = ({ enabled = true } = {}) => {
  const {
    security: { isValid: validSecurityLicense },
    enterprise: { isValid: validEnterpriseLicense }
  } = useLicenseCheck();
  const hasValidLicense = validSecurityLicense || validEnterpriseLicense;
  const { data, isLoading } = useQuery({
    queryKey: [AI_CONFIGURATION_QUERY_STRING],
    queryFn: () => defaultOnError(
      getAIReportConfiguration(),
      i18n.t("notifications.ai_configuration_fetch_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.ai_configuration_fetch_title", { ns: "enterprise_ai" })
    ),
    enabled: enabled && hasValidLicense
  });
  return {
    data: data != null ? data : {
      isEnabled: false
    },
    isLoading
  };
};
export default useAIConfiguration;
